import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { DeskTable, type Column } from '@/components/common/DeskTable'
import PageFrame from '@/components/common/PageFrame'
import StatusBadge from '@/components/common/StatusBadge'
import { backofficeApi, type CompanyBank } from '@/lib/api-client'

export function BanksPage() {
  const [sp, setSp] = useSearchParams()
  useEffect(() => {
    if (!sp.has('sort') && !sp.has('order') && !sp.has('dir')) return
    const next = new URLSearchParams(sp)
    next.delete('sort')
    next.delete('order')
    next.delete('dir')
    setSp(next, { replace: true })
  }, [sp, setSp])
  const q = useQuery({ queryKey: ['company-banks'], queryFn: () => backofficeApi.listBanks() })

  const columns: Column<CompanyBank>[] = [
    { key: 'bank', header: 'Bank', sticky: true, mobile: 'title', cell: (r) => r.bank_name },
    { key: 'number', header: 'Number', mobile: 'subtitle', cell: (r) => <span className="font-mono">{r.account_number}</span> },
    { key: 'name', header: 'Account holder', mobile: 'field', cell: (r) => r.account_name },
    { key: 'ccy', header: 'Currency', mobile: 'field', cell: (r) => r.currency },
    { key: 'status', header: 'Status', mobile: 'status', cell: (r) => <StatusBadge status={r.is_active ? 'active' : 'inactive'} /> },
  ]

  return (
    <PageFrame title="Company Banks" description="Company accounts clients can deposit to. Environment-managed. Contact engineering to change.">
      <DeskTable
        columns={columns}
        rows={q.data ?? []}
        rowKey={(r) => r.id}
        loading={q.isLoading}
        error={q.error}
        emptyTitle="No company banks"
        emptyDescription="Environment-managed. Contact engineering to add one."
      />
    </PageFrame>
  )
}
